import { has, head, isEmpty, isNil, last, map, median, pipe, toPairs } from 'ramda';

function percentile(data, percentile) {
  var index = (percentile / 100) * data.length;
  var result;
  if (Math.floor(index) == index) {
    result = (data[index - 1] + data[index]) / 2;
  } else {
    result = data[Math.floor(index)];
  }
  return result;
}

export const basicBoxPlotParser = (chartData) => {
  if (has('transformedData', chartData)) return;

  const { axis, series } = chartData;
  const serie = head(series);

  const dataById = chartData.data.reduce((data, item) => {
    const id = (item[axis] || '').replace(/-\d{4}/g, '');
    const value = item[serie] && Number(item[serie].replace(',', '.'));

    if (!isEmpty(id) && !isNaN(value)) {
      if (has(id, data)) {
        data[id].push(value);
      } else {
        data[id] = [value];
      }
    }

    return data;
  }, {});

  const data = pipe(
    toPairs,
    map(([id, values]) => {
      const sortedValues = values.filter((item) => !isNil(item) && !isEmpty(item)).sort();

      return {
        id,
        min: head(sortedValues),
        max: last(sortedValues),
        q1: percentile(sortedValues, 25),
        q3: percentile(sortedValues, 75),
        median: median(sortedValues),
      };
    })
  )(dataById);

  chartData.transformedData = data;
};
